import styled from '@emotion/styled';

import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { loadMainSection } from '../../slice';
import { isPC } from '../../../../util/window/getDevice';
import MainSectionFactory from './MainSectionFactory';
import { createMainSkeleton } from '../m/shared/skeleton/CreateMainSkeleton';
import { createMainSkeletonPC } from '../pc/shared/skeleton/CreateMainSkeleton';
import { useAppSelector } from '../../../shared/store';

const Container = styled.div<{ isHeightAuto: boolean }>`
  min-height: ${({ isHeightAuto }) => (isHeightAuto ? 'auto' : '100vh')};
`;

const SkeletonWrapper = styled.div`
  ${isPC ? 'padding: 40px 0; margin: 0 auto;' : 'margin: 16px 0'};
`;

interface Props {
  sectionKey: string;
}

const MainSectionInViewDispatcher = ({ sectionKey }: Props) => {
  const section = useAppSelector(({ main }) => main.sectionDictionary[sectionKey]);
  const { ref, inView } = useInView({ rootMargin: isPC ? '1000px' : '500px' });
  const [isLoadSectionId, setIsLoadSectionId] = useState(false); // 중복호출 막기
  const Skeleton = isPC ? createMainSkeletonPC(section?.type) : createMainSkeleton(section?.type);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoadSectionId || !inView) {
      return;
    }
    dispatch(loadMainSection(sectionKey));
    setIsLoadSectionId(true);
  }, [dispatch, sectionKey, inView, isLoadSectionId]);

  return (
    <Container ref={ref} isHeightAuto={isLoadSectionId}>
      {!section?.hasLoaded ? <SkeletonWrapper>{Skeleton}</SkeletonWrapper> : <MainSectionFactory section={section} />}
    </Container>
  );
};

export default MainSectionInViewDispatcher;
